import { getEndPoint } from './getEndPoint'
import { getOrphanPage } from './getOrphanPage'
import { translateCategory } from 'js/locale/localizationHelper'
export const getPageBySlug = (category, slug) => {
  if (!category) return getOrphanPage(slug)
  // do the same transformation as in the fetchData function in wpFetch.js
  let pageFolder
  switch (category) {
    case 'posts':
      pageFolder = 'blog'
      break
    case 'marketing':
      pageFolder = 'news'
      break
    default:
      pageFolder = category
  }

  return import(
    /* webpackChunkName: "[request]" */ `wp-data/${pageFolder}/${slug}.json`
  )
    .catch(() =>
      getEndPoint(
        'wp/v2/' + translateCategory(category) + `?slug=${slug}&_embed`
      )
    )
    .then(json => {
      return json[0]
    })
}
